import { DateFormats, formatDate } from '@strata/helper-functions';
import { type ColumnDef, Grid, PrimaryData, SecondaryData } from '@strata/react-grid';
import { useNavigate } from 'react-router';

import { IncidentAnalytics } from 'components/incidentManagement/IncidentAnalytics';
import { ListPageHeader } from 'components/shared/ListPageHeader';
import { AppRoutes, getIncidentDetailsPath } from 'services/routes';
import { useGetIncidentsQuery } from 'store/api/oopsApi';

export interface Incident {
    id: string;
    name: string;
    startedAt: string;
    description: string;
    missingQualityCheck: string;
    primaryImpactedServiceName: string;
    resolvedAt?: string;
}

const columns: ColumnDef<Incident>[] = [
    {
        accessorKey: 'name',
        header: 'Incident Title',
        size: 200,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        accessorKey: 'primaryImpactedServiceName',
        header: 'Primary Impacted Service',
        size: 180,
    },
    {
        accessorKey: 'startedAt',
        header: 'Started At',
        size: 140,
        cell: ({ getValue }) => (
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
        ),
    },
    {
        accessorKey: 'resolvedAt',
        header: 'Resolved At',
        size: 140,
        cell: ({ getValue }) => (
            <SecondaryData
                data={getValue() ? formatDate(getValue(), DateFormats.DATE_TIME) : '--'}
            />
        ),
    },
];

export const ViewIncidents = () => {
    const navigate = useNavigate();
    const { data: incidents, isFetching } = useGetIncidentsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    return (
        <div className="sds_list-page incident-overview">
            <ListPageHeader
                pageTitle="Incidents"
                buttons={[
                    {
                        label: 'Declare Incident',
                        path: AppRoutes.declareIncident,
                    },
                ]}
            />
            <IncidentAnalytics incidents={incidents ?? []} />
            <div className="sds_list-page__grid incident-overview__grid">
                <Grid
                    data={incidents ?? []}
                    columns={columns}
                    isLoading={isFetching}
                    sortProperties={[{ id: 'startedAt', desc: true }]}
                    onRowClick={(incident) => {
                        navigate(getIncidentDetailsPath(incident.id));
                    }}
                />
            </div>
        </div>
    );
};
